// Après connexion, revenir à la page de consentement d'un connecteur MCP (OAuth) au lieu de l'accueil : sans cela, la
// demande de claude.ai serait perdue. Limité à cette page, le reste de l'application garde son comportement.
const KEY = 'deepflow.apres_connexion';
const CONSENT = '/agent-access/connecteur';

export const rememberReturnPath = (location = window.location) => {
  const path = location?.pathname || '';
  if (!path.startsWith(CONSENT)) return;
  try {
    sessionStorage.setItem(KEY, path + (location.search || ''));
  } catch (error) {
    // Stockage indisponible (navigation privée) : retour à l'accueil.
  }
};

export const takeReturnPath = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && path.startsWith(CONSENT) ? path : null;
  } catch (error) {
    return null;
  }
};
